import Layout from "../../components/Layout/Layout";

export default function AppointmentForm() {
    return (
        <>
            <Layout />
        </>
    )
}